import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=46cc6566&scoped=true&"
import script from "./BannerManage.vue?vue&type=script&lang=js&"
export * from "./BannerManage.vue?vue&type=script&lang=js&"
import style0 from "./BannerManage.vue?vue&type=style&index=0&id=46cc6566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc6566",
  null
  
)

export default component.exports